import { Component, Input, input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { OAuthService } from "../../../../services/oauth/oauth.service";
import { LocalStorageService } from "../../../../local-storage/local-storage.service";
import { CombiPackageService } from "../../../../services/combipackage/combipackage.service";
import { doOAuth } from "../oauth.util";
import { UserAPI } from "../../../../model";
import { UserService } from "../../../../services/user/user.service";
import { ModalService } from "../../../shared/modal/modal.service";

@Component({
  standalone: false,
  selector: 'app-userapi-shared-oauth',
  templateUrl: './userapi-shared-oauth.component.html'
})
export class UserApiSharedOAuthComponent {
  @Input() userApi: UserAPI;
  readonly configured = input(true);

  constructor(protected route: ActivatedRoute,
              protected router: Router,
              protected userService: UserService,
              protected oAuthService: OAuthService,
              protected combiPackageService: CombiPackageService,
              protected localStorageService: LocalStorageService,
              protected modalService: ModalService<any>) {
  }

  async letsDoOAuth() {
    doOAuth(this.userService.getUser(), this.userApi, this.combiPackageService, this.oAuthService, this.localStorageService, this.modalService, this.router);
  }

}
